(ns frontend.view.grid.indirect-holdings-grid.view
  (:require
   [frontend.routing :as routing]
   [potpuri.core :as potpuri]
   [frontend.view.grid.indirect-holdings-grid.events :as events]
   [frontend.view.grid.indirect-holdings-grid.db :as db]
   [frontend.ux-overhaul.listing.indirect-holding.view :as indirect-holding-listing]
   [common.localization :as loc]
   [common.fields.table-column-widths :as widths]
   [common.schema.registry :as registry]
   [frontend.react.virtualized.scrollable-grid.view :as scrollable-grid]
   [frontend.react.virtualized.scrollable-grid.common :as grid]
   [frontend.react.virtualized.scrollable-grid.kanban :as kanban]
   [frontend.react.virtualized.scrollable-grid.components :as grid-components]
   [frontend.db :as app-db]
   [frontend.utils :as fu]
   [frontend.local-storage :as ls]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.state.current-session :as session]
   [common.attribute :as attribute]
   [frontend.react.virtualized.utils :as vu]
   [common.teams :as teams]
   [frontend.view.grid.common.utils :as grid-utils]
   [reagent.core :as r]
   [frontend.view.grid.common.components :as components]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.tenant-customizations :as tenant-customizations]
   [frontend.view.grid.common.no-results-view :as no-results-view]
   [frontend.view.named-view.events :as named-view-events]
   [frontend.view.components.grid-filters.view :as grid-filters]
   [ui.components.button.view :as button]))

(defonce select-width 30)

(defn column
  [args]
  (let [{:keys [label attribute field-schema filter-data sorting-disabled? width hover-atom
                recompute-grid-sizes! flex-grow]}
        args
        default-width (-> (widths/get-column-width attribute)
                          :default-width
                          (or widths/default-width))]
    {:label               label
     :data-key            attribute
     :field-schema        field-schema
     :filter-data         filter-data
     :update-filter!      (fn [k filter-data]
                            (grid/set-filter (events/setup-args) k filter-data))
     :sort-disabled?      (boolean sorting-disabled?)
     :min-width           (-> (widths/get-column-width attribute)
                              :min-width
                              (or widths/min-width))
     :max-width           (-> (widths/get-column-width attribute)
                              :max-width
                              (or widths/max-width))
     :default-width       default-width
     :width               (or width default-width)
     :set-width           width
     :begin-width-update! (partial grid/begin-width-update! hover-atom attribute)
     :update-width!
     (partial grid/update-width! (events/setup-args) recompute-grid-sizes! hover-atom attribute)
     :end-width-update!   (partial grid/end-width-update! hover-atom attribute)
     :get-styling         (partial grid/get-styling hover-atom attribute)
     :flex-grow           flex-grow}))

(defn toolbar-actions
  [{:keys [view-mode]}]
  (let [all-teams (->> @session/entity-types
                       :entity.type/team
                       (remove :common/disabled?))
        account-teams (teams/resolve-account-teams @session/account all-teams)]
    [{:toolbar-button? true
      :dropdown-action? true
      :ord       2
      :hidden?   (fn []
                   (= view-mode :board-mode))
      :primary-button? false
      :add-ellipsis? true
      :on-select (fn [_e]
                   (grid/open-select-columns-curtain (events/setup-args)))
      :label     (loc/tr :action/select-columns)}
     (grid-utils/export-button {:account-teams  account-teams
                                :button-ord     3
                                :grid-state     db/indirect-holdings
                                :column-keys-fn events/resolve-column-keys})
     (grid-utils/export-with-persons-button {:account-teams  account-teams
                                             :entity-type    :entity.type/calculated-indirect-holding
                                             :grid-state     db/indirect-holdings
                                             :button-ord     4
                                             :column-keys-fn events/resolve-column-keys})
     (when (= view-mode :board-mode)
       {:toolbar-button? false
        :dropdown-action? true
        :ord       15
        :add-ellipsis? true
        :label     (loc/tr :card-settings)
        :on-select (fn [_e]
                     (events/open-card-settings!))})
    ]))

(defn toolbar-buttons-renderer
  []
  [:div])

(defn create-props-atom
  [selected sorted-indirect-holdings filters grid-store recompute-grid-sizes! hover-atom]
  (let [tenant-schema @session/tenant-schema
        columns
        (vec
         (keep (fn [k]
                 (let [field-schema (registry/get-field-schema tenant-schema k)
                       label (if (and (tenant-customizations/alj?) ;; Do not show "Holding - " for ALJ
                                      (sequential? k)
                                      (= (first k) :indirect-holding/holding-target))
                               (attribute/attribute-label tenant-schema (rest k))
                               (attribute/attribute-label tenant-schema k))]
                   (column {:label             label
                            :attribute         k
                            :field-schema      field-schema
                            :filter-data       (get filters k)
                            :sorting-disabled? false
                            :width             (grid/get-saved-width (events/setup-args) k)
                            :hover-atom        hover-atom
                            :recompute-grid-sizes! recompute-grid-sizes!
                            :flex-grow         1})))
               (events/resolve-column-keys)))]
    (r/atom
     {:grid-store              grid-store
      :setup-args              (events/setup-args)
      :selected                selected
      :header-height           50
      :select-width            select-width
      :editable-grid?          false
      :min-columns-width       30
      :height                  (- (or (:height @app-db/window) 400)
                                  75) ;; TODO: lazy - fixed 120px for button row in this view
      :avail-height            (- (or (:height @app-db/window) 400)
                                  75) ;; TODO: lazy - fixed 120px for button row in this view
      :useDynamicRowHeight     false  ;; TODO: kebab-case
      :row-height              40     ;(fn [index] 40)
      :row-count               (if (coll? sorted-indirect-holdings)
                                 (count sorted-indirect-holdings)
                                 0)
      :scrollToIndex           0
      :columns                 columns
      :overscan-count          1
      :no-rows-renderer        (fn []
                                 (r/as-element
                                  [:div.grid-no-rows
                                   (cond (not (:loaded @db/indirect-holdings))
                                         (loc/tr :grid-loading-data)

                                         :else
                                         [no-results-view/no-entities-found-view])]))
      :on-row-click!           (fn [row]
                                 (let [_data (when (< row (count sorted-indirect-holdings))
                                              (nth sorted-indirect-holdings row))]
                                   ;; TODO: open indirect holdgin (association) editor
                                   #_(routing/open-entity (:db/id data))))
      :on-cell-click           (fn [row col]
                                 (grid/make-cell-active {:row   row
                                                         :col   col
                                                         :state hover-atom}))
      :is-sorted-by?           (partial grid/is-sorted-by db/view-settings)
      :is-secondary-sorted-by? (partial grid/is-secondary-sorted-by db/view-settings)
      :sort-by!                (fn [k dir]
                                 (grid/set-sort-by (events/setup-args) k dir))
      :reorder-columns!        (fn [dragged-column after-column]
                                 (grid/reorder-columns! (events/setup-args)
                                                        dragged-column
                                                        after-column))
      :can-filter?             (fn [_k]
                                 true)
      :resizing-column         (some-> @hover-atom
                                       (get :resize-start-width)
                                       (first)
                                       (key))
      :recompute-grid-sizes!   recompute-grid-sizes!
      :all-selection!          (fn []
                                 (let [selected (:selected @db/indirect-holdings)]
                                   (if (or (= :all selected) (not-empty selected))
                                     (grid/clear-selection! (events/setup-args))
                                     (swap! db/indirect-holdings assoc :selected :all))))
      :select-action-renderer  toolbar-buttons-renderer
      :on-row-select!          (fn [index checked]
                                 (let [data (when (< index (count sorted-indirect-holdings))
                                              (nth sorted-indirect-holdings index))
                                       indirect-holding-id (:db/id data)]
                                   (if (= selected :all)
                                     (grid/select-all-but (events/setup-args) indirect-holding-id)
                                     (if (boolean checked)
                                       (swap! db/indirect-holdings assoc-in
                                         [:selected indirect-holding-id]
                                         true)
                                       (swap! db/indirect-holdings potpuri/dissoc-in
                                         [:selected indirect-holding-id])))))
      :row-data-getter         (r/partial grid/default-row-data-getter
                                          sorted-indirect-holdings
                                          selected)})))

(defn render
  [grid-store _args]
  (let [tenant-schema @session/tenant-schema
        hover-atom (r/atom {:hover {:col nil :row nil}})
        ;;for saving grid references:
        recompute-grid-sizes! (fn []
                                (js/setTimeout
                                 (partial vu/recompute-grid-sizes-with-state! grid-store)
                                 0))]
    (fn [{:keys [view-mode]}]
      (let [selected (:selected @db/indirect-holdings)
            filters {}
            #_@db/indirect-holding-filters ;;TODO later
            sorted-indirect-holdings (:sorted-grid-entities @db/indirect-holdings)
            grid-atom (create-props-atom selected
                                         sorted-indirect-holdings
                                         filters
                                         grid-store
                                         recompute-grid-sizes!
                                         hover-atom)
            show-quick-filters? (:show-quick-filters? @db/indirect-holdings)
            card-settings? (:card-settings? @db/kanban)
            setup-args @(r/track events/setup-args)
            filters-props {:minimized?            (not show-quick-filters?)
                           :hide-maximize?        true
                           :universal-search?     true
                           :search-placeholder    (loc/tr :search-for-a-holding)
                           :setup-args            (events/setup-args)
                           :set-universal-search! (r/partial grid/set-universal-search! setup-args)
                           :set-name-search!      (r/partial grid/set-name-search! setup-args)
                           :hide-named-views?     true
                           :named-views           (events/named-views)
                           :current-view          @db/view-settings
                           :columns               (events/resolve-column-keys)
                           :all-columns           (events/resolve-column-key-universe)
                           :get-column-label      (fn [a]
                                                    (attribute/attribute-label @session/tenant-schema a))
                           :set-filter!           (fn [k filter-data]
                                                    (grid/set-filter (events/setup-args) k filter-data))
                           :edit-filter!          (fn [k filter-data]
                                                    (grid/open-filter-curtain
                                                     {:field-key      k
                                                      :field-schema   (registry/get-field-schema tenant-schema
                                                                                                 k)
                                                      :options        (->>
                                                                       (events/resolve-column-key-universe)
                                                                       (map (juxt identity
                                                                                  (partial
                                                                                   registry/get-field-schema
                                                                                   tenant-schema))))
                                                      :current-filter filter-data
                                                      :update-fn!     (fn [k filter-data]
                                                                        (grid/set-filter (events/setup-args)
                                                                                         k
                                                                                         filter-data))}
                                                     nil))
                           :hide-qf-attributes    []
                           :load-view!            (fn [named-view]
                                                    (events/load-view! named-view)
                                                    (grid/clear-selection! {:state db/indirect-holdings}))
                           :save-view!            events/save-current-view!
                           :delete-view!          named-view-events/delete-view!
                           :toggle-minimize!      (fn []
                                                    (events/toggle-quick-filters!)
                                                    (.setTimeout js/window recompute-grid-sizes! 1000))}
            hiccup
            (if card-settings?
              [kanban/card-settings-view (events/setup-args)]
              [:<>
               [grid-filters/view
                filters-props]
               [:div
                {:class "flex flex-auto ps-4"}
                [:div
                 {:class-name (fu/cs "grid-view-content"
                                     (when-not show-quick-filters? "named-views-minimized")
                                     (when (= view-mode :board-mode) "board-view"))}
                 (if (= view-mode :board-mode)
                   [kanban/view
                    {:setup-args   (events/setup-args)
                     :card-actions [#_{:id         "open-indirect-holding"
                                       :label      (loc/tr :open)
                                       :icon       "fal fa-folder-open"
                                       :on-select! (fn [{:keys [entity]}]
                                                     ;; TODO: open indirect-holding (association) editor
                                                     #_(routing/open-entity (:db/id entity)))}]}]
                   [scrollable-grid/view
                    {:props-atom grid-atom
                     :hover-atom hover-atom}])
                 ;; Curtains ;;TODO needed later?
                 #_[person-edit-view/person-edit-view]
                 #_[person-search-curtain/curtain]]]])]
        #_(when debug/DEBUG-GRID-SCROLL
            (logging/log "Render Holdings Grid " (- (.getTime (js/Date.)) start-time)
                         "\n Hiccup " (- start-hiccup-time start-time)))
        hiccup))))

(defn toolbar
  [args]
  (let [view-mode (or (:view-mode @db/view-settings)
                      (:view-mode (ls/get-in (events/ls-path)))
                      (:initial-mode args)
                      :grid-mode)
        board-mode? (= view-mode :board-mode)
        card-mode (or (:card-mode @db/kanban)
                      :short-card)
        has-empty-groups? (when board-mode?
                            (kanban/has-empty-groups? @(r/track events/setup-args)))]
    [:div
     {:class "px-4 py-1 flex items-center justify-between
                   bg-base-light
                   border-b border-solid border-base-light-border-paler"}
     [:div
      {:class "w-full flex justify-between gap-6"}
      [:div
       {:class "flex gap-2 items-center"}
       [:div
        {:class "flex gap-2 items-center"}
        [:div
        {:class "flex items-center gap-2"}
         [:label
          {:class "font-semibold"}
          (loc/tr :indirect-holdings)]
        [:span
         {:class "h-5 px-2 flex items-center justify-center text-xs font-semibold text-base-light-text bg-complement-regular rounded-full"}
         (count @db/sorted-kanban-entities)]]

        [grid-components/named-view-selector
         {:named-views        (events/named-views)
          :current-view       @db/view-settings
          :load-view!         (fn [id]
                                (events/load-view! (events/named-view-by-id id))
                                (grid/clear-selection! {:state db/indirect-holdings}))
          :delete-view!       named-view-events/start-delete-view!
          :accounts-with-view-access (session/active-accounts-with-module-access :module/portfolio)
          :save-current-view! events/save-current-view!}]

        (when board-mode?
          [grid-components/sort-selector
           {:view-settings   @db/view-settings
            :entity-type     :entity.type/calculated-indirect-holding
            :sortable-fields  (events/resolve-column-key-universe)
            :set-sort-by!    (fn [k dir]
                               (grid/set-sort-by (events/setup-args) k dir))}])

        (when board-mode?
          [grid-components/grouped-by-selector
           {:view-settings      @db/view-settings
            :entity-type        :entity.type/calculated-indirect-holding
            :default-grouped-by :indirect-holding/fund
            :grouped-by-fields  (->> (events/resolve-column-key-universe)
                                     (filter grid/groupable-attribute?))
            :set-grouped-by!    (fn [k]
                                  (swap! db/view-settings assoc :grouped-by k)
                                  (ls/update-in (events/ls-path)
                                                assoc
                                                :grouped-by
                                                k))}])]]
      [:div
       {:class "flex justify-content-end items-center gap-2"}
       (when (and board-mode? (not= card-mode :short-card))
         [button/square-secondary-open
          {:on-click (fn [_] (events/collapse-all!))
           :tooltip  (loc/tr :collapse-all)}
          [:i.fal.fa-compress-alt]])
       (when (and board-mode? (= card-mode :short-card))
         [button/square-secondary-open
          {:tooltip (loc/tr :expand-all)
           :on-click   (fn [_] (events/expand-all!))}
          [:i.fal.fa-expand-alt]])

       [button/square-secondary-open
        {:tooltip (grid-components/view-mode-tooltip board-mode?)
         :on-click   (fn [_]
                       (events/switch-mode! view-mode))}
        (if board-mode?
          [:i.fal.fa-table]
          [:i.fal.fa-signal-3.fa-rotate-180.kanban-icon])]

       (when (and board-mode? has-empty-groups?)
         [grid-utils/hide-empty-kanban-groups-toggle "indirect-holdings-grid-toolbar" db/kanban])

       [:div.toolbar-dropdown
        (zap-toolbar/dropdown (->> (toolbar-actions {:view-mode view-mode})
                                   (filter :dropdown-action?)
                                   (remove (fn [{:keys [hidden?]}]
                                             (when (fn? hidden?)
                                               (hidden?))))
                                   (sort-by :ord))
                              true)]]]]))

(defn view
  [_args]
  (let [grid-store (atom {})
        close-atom (atom false)
        resizer (fn []
                  (js/setTimeout (partial vu/recompute-grid-sizes-with-state! grid-store) 100))]
    (.addEventListener js/window "resize" resizer)
    (r/create-class
     {:component-did-mount    (fn []
                                (fu/timeout 10 (partial events/setup close-atom)))
      :component-will-unmount (fn []
                                (reset! close-atom true)
                                (events/cleanup)
                                (.removeEventListener js/window "resize" resizer))
      :reagent-render         (partial render grid-store)})))

(defmethod routing/render-view :indirect-holdings-grid
  []
  (if (session/new-grid-2023?)
    [default-page-layout/view
     [:<>
      [indirect-holding-listing/page-content]]]
    (let [view-mode (or (:view-mode @db/view-settings)
                        (:view-mode (ls/get-in (events/ls-path)))
                        :grid-mode)]
      [default-page-layout/view
       [:<>
        [components/card-settings-toolbar
         [toolbar {:view-mode view-mode}] db/kanban events/close-card-settings!]
        [view {:view-mode view-mode}]]])))
